module.exports = __webpack_public_path__ + "static/media/img-add-video.c1960a6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/img-add-video.svg
// module id = 31
// module chunks = 0